import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { CBreadcrumb, CBreadcrumbItem } from '@coreui/react-pro'
import { GlobalVariablesContext } from 'src/contexts/globalVariableContext'

export const AppBreadcrumb = () => {
  const { t } = useTranslation()
  const { tenderName } = useContext(GlobalVariablesContext)

  const currentLocation = useLocation().pathname
  const pathSegments = currentLocation.split('/').filter((segment) => segment !== '')

  return (
    <CBreadcrumb className='m-0 ms-2'>
      <CBreadcrumbItem href='/tender-overview'>{t('Homepage')}</CBreadcrumbItem>

      {pathSegments.includes('tender-detail-view')
        ? pathSegments.slice(0, -1).map((breadcrumb, index) => {
            const path = `/${pathSegments.slice(0, index + 1).join('/')}`
            return (
              <CBreadcrumbItem
                className={`${breadcrumb}`}
                key={index}
                {...(pathSegments.length - 2 === index ? { active: true } : { href: path })}
              >
                {pathSegments.length - 2 === index ? t(breadcrumb) : t(breadcrumb)}
              </CBreadcrumbItem>
            )
          })
        : pathSegments.map((breadcrumb, index) => {
            const path = `/${pathSegments.slice(0, index + 1).join('/')}`

            return (
              <CBreadcrumbItem
                className={`text-capitalize ${breadcrumb}`}
                key={index}
                {...(pathSegments.length - 1 === index ? { active: true } : { href: path })}
              >
                {pathSegments.length - 1 === index ? t(breadcrumb) : t(breadcrumb)}
              </CBreadcrumbItem>
            )
          })}
      {pathSegments.includes('tender-detail-view') && (
        <CBreadcrumbItem className='text-capitalize active tender-name'>
          : {tenderName}
        </CBreadcrumbItem>
      )}
    </CBreadcrumb>
  )
}
export default React.memo(AppBreadcrumb)
